import React from 'react';
import './_styles.scss';
import Button from '../../../../../common/components/Button/Button';
import { ExecutionStatusCell } from '../../components/TasksTableComponents/TasksTableComponents';
import { Dialog } from '../../../../../common/components/Dialog/Dialog';

const TaskStepsDialog = ({ open, onClose, steps = [], taskName = '', taskId = '' }) => {
  if (!steps || steps.length === 0) return null;

  const actions = [
    <Button key="close" onClick={onClose} color="secondary">
      Close
    </Button>,
  ];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={`Task Steps - ${taskName}`}
      maxWidth="md"
      fullWidth
      actions={actions}
      className="task-steps-dialog"
    >
      <div className="task-steps-content">
        <div className="task-steps-header">
          <p>
            Task ID: <span className="task-id">{taskId}</span>
          </p>
          <p>
            Total Steps: <span className="steps-count">{steps.length}</span>
          </p>
        </div>

        <div className="steps-list">
          {steps.map((step, index) => (
            <div key={step.stepId || index} className="step-item">
              <div className="step-number">{index + 1}</div>
              <div className="step-content">
                <div className="step-header">
                  <h4 className="step-name">{step.name}</h4>
                  <div className="step-status">
                    <ExecutionStatusCell status={step.status} />
                  </div>
                </div>
                <div className="step-details">
                  <div className="step-detail-item">
                    <span className="label">Type:</span>
                    <span className="value">{step.type}</span>
                  </div>
                  {step.description && (
                    <div className="step-detail-item">
                      <span className="label">Description:</span>
                      <span className="value">{step.description}</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Dialog>
  );
};

export default TaskStepsDialog;
